var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatestArrival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2174 1C8.69305 1 5.82609 3.86695 5.82609 7.39131C5.82609 9.08638 6.49946 10.7121 7.69806 11.9106C8.89666 13.1092 10.5223 13.7826 12.2174 13.7826C15.7417 13.7826 18.6087 10.9248 18.6087 7.39131C18.6087 3.86695 15.7417 1 12.2174 1ZM12.2174 2.96304C14.6552 2.96304 16.6457 4.94435 16.6457 7.39131C16.6457 9.83829 14.6552 11.8196 12.2174 11.8196C11.043 11.8196 9.9166 11.353 9.08614 10.5225C8.25568 9.6921 7.78913 8.56575 7.78913 7.39131C7.78913 6.21685 8.25568 5.09051 9.08614 4.26005C9.9166 3.42959 11.043 2.96304 12.2174 2.96304ZM11.3043 4.65217V8.02131L14.2169 9.70131L14.9017 8.51435L12.6739 7.22695V4.65217H11.3043ZM14.9565 14.6957V17.4348H4V19.2609H14.9565V22L18.6087 18.3478L14.9565 14.6957ZM18.6087 18.3478V22H20.4348V14.6957H18.6087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestArrival);
export default __webpack_public_path__ + "static/media/latest-arrival.2ef88498db1f167fa34601e4c9a791c4.svg";
export { ForwardRef as ReactComponent };